import { render } from "./pos_header_component.vue?vue&type=template&id=79674868"
import script from "./pos_header_component.vue?vue&type=script&lang=js"
export * from "./pos_header_component.vue?vue&type=script&lang=js"

import "./pos_header_component.vue?vue&type=style&index=0&id=79674868&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__